import dayjs from 'dayjs';
import { Transaction } from './types';

export const EMPTY_TRANSACTION: Transaction = {
    id: undefined,
    pbmId: null,
    pharmNabp: null,
    rxNum: null,
    dateFilled: null,
    groupId: null,
    cardHolderId: null,
    submittedPc: null,
    dateOfBirth: null,
    genderCode: "" as string,
    patientFirstName: null,
    patientLastName: null,
    patientMiddleName: null,
    refillCode: 0,
    daysSupply: 0,
    ndc: null,
    ingrCostSubmitted: null,
    prescriberId: null,
    dateWritten: null,
    numRefillsAuthorized: null,
    unc: null,
    qtyDispensed: null,
    claimMessage: null,
    dateEnteredByPharmacy: null,
    dateReceivedByNASH: null,
    fileOutputId: null,
    inputFileLogId: null,
    pending: true,
    claimId: null,
    otherId: null,
    nashPatientId: null,
    nashReferralOrg: null,
    drugDispensed: null,
    drugStrength: null,
    priorAuthApprovalDate: null,
    priorAuthExpirationDate: null,
    travelCost: null,
    organizationId: null,
    planPay: null
}

export const TEST_TRANSACTION: Transaction = {
    id: 1,
    pbmId: 2,
    pharmNabp: "4580975",
    rxNum: '7444555',
    dateFilled: dayjs(),
    groupId: 'TESTGROUP',
    cardHolderId: 'Card 1234567890*TEST-',
    submittedPc: '01',
    dateOfBirth: dayjs(),
    genderCode: "Male",
    patientFirstName: 'Geoff',
    patientLastName: 'Ox',
    patientMiddleName: 'A',
    refillCode: 1,
    daysSupply: 30,
    ndc: '16729004517',
    //ndc: 123,
    ingrCostSubmitted: 499.99,
    prescriberId: 'BW4590419',
    dateWritten: dayjs(),
    numRefillsAuthorized: 2,
    unc: 300.23,
    qtyDispensed: 500,
    claimMessage: "NASH PRODUCT",
    dateEnteredByPharmacy: dayjs(),
    dateReceivedByNASH: dayjs(),
    fileOutputId: null,
    inputFileLogId: null,
    pending: true,
    claimId: 'CLAIM123456',
    otherId: 'OTHER987654',
    nashPatientId: 'NASHPT001',
    nashReferralOrg: 'NASH Referral Center',
    drugDispensed: 'Metformin',
    drugStrength: '500mg',
    priorAuthApprovalDate: dayjs(),
    priorAuthExpirationDate: dayjs().add(1, 'year'),
    travelCost: 25.50,
    organizationId: 1,
    statusCode: 'P',
    serviceProviderId: 123456,
    copay: 10.25,
    patientPayAmount: 10.25,
    pharmacyTotalPaid: 1.25,
    pharmacyIngredientCostPaid: 1.25,
    pharmacyDispensingFeePaid: .25,
    pharmacyTaxPaid: .02,
    sellIngredientCost: .22,
    sellDispensingFee: .23,
    sellTax: .3,
    totalClientBilled: 10.25,
    processDateTime: dayjs(),
    planPay: 50.00
}
